import React from 'react'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from 'components/Dialog'
import {getTestEmail, getTestPhone} from 'utils/utils'

class TestMessage extends React.Component {
    constructor(props) {
        super(props)

        const address = props.type === 'email' ? getTestEmail() : getTestPhone()

        this.state = {
            messageTest: false,
            address
        }
    }

    openSendTest = () => {
        this.setState({ messageTest: true })
    }

    closeSendTest = () => {
        this.setState({ messageTest: false })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSend = () => {
        this.props.handleSend(this.state.address)
        this.closeSendTest()
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <Button variant="contained"
                    onClick={this.openSendTest}
                    style={{background: '#4cae4c', color: '#FFF', marginTop: '20px', display: 'block'}}
                >
                    {intl.formatMessage({id: "app.confirm_send_test"})}
                </Button>
                {this.state.messageTest &&
                    <Dialog
                        open={this.state.messageTest}
                        onClose={this.closeSendTest}
                    >
                        <DialogTitle>
                            {intl.formatMessage({id: "sidebar.send_to"}, {...this.props.title})}
                        </DialogTitle>
                        <DialogContent>
                            {intl.formatMessage({id: "sidebar.test_message_desc"})}
                            <TextField variant="standard"
                                style={{width: '100%', marginTop: '20px'}}
                                value={this.state.address}
                                onChange={this.handleChange}
                                label={intl.formatMessage({id: "sidebar.test_address"})}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                inputProps={{
                                    name: 'address'
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.closeSendTest} color="primary">
                                {intl.formatMessage({id: "app.confirm_cancel"})}
                            </Button>
                            <Button variant="contained"
                                disabled={this.state.address.replace(/\s/g, '') === ''}
                                onClick={this.handleSend}
                                color="primary"
                            >
                                {intl.formatMessage({id: "app.confirm_send"})}
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </React.Fragment>
        )
    }
}

export default injectIntl(TestMessage)
